import { createUseStyles, useTheme } from 'react-jss';
import { Trans } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { AnalyticsCategoryProvider, Categories } from '@app/analytics';
import { Theme } from '@app/theme';
import { panelSubscriptionSettingsByIdSelector } from 'store';

import { SubscriptionFormBg } from './SubscriptionFormBg';

const useStyles = createUseStyles((theme: Theme) => ({
  text: {
    ...theme.fonts.body,
    color: theme.colors.inkSecondary,
    textAlign: 'center',
  },
}));

export const PanelSubscriptionFormSuccess = () => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { id } = useParams();

  const settings = useSelector((state: any) =>
    panelSubscriptionSettingsByIdSelector(state, id),
  );

  if (!settings) {
    return <Navigate to={`subscribe-panel/${id}`} />;
  }

  return (
    <AnalyticsCategoryProvider category={Categories.SUBSCRIBE_PANEL}>
      <SubscriptionFormBg
        logoUrl={settings ? settings.logoUrl : undefined}
        title={<Trans i18nKey="panelSubscription.success.title" />}
      >
        <p className={classes.text}>
          <Trans i18nKey="panelSubscription.success.text" />
        </p>
      </SubscriptionFormBg>
    </AnalyticsCategoryProvider>
  );
};
